import { CircleChangeSponsorshipRequest } from '@calm/evexia-web-sdk';
import { useSponsorshipMutation } from '@rhg/hooks/use-sponsorship-mutation';
import { PARTNER_MEMBER_ACTIVATION_TOKEN_HEADER } from '@rhg/utils/partner-activation';

export function useChangeSponsorship() {
    const { mutate, mutateAsync, ...otherProps } =
        useSponsorshipMutation<CircleChangeSponsorshipRequest>(
            (api, { partnerId, circle, request, activationToken }) => {
                const params = {
                    partnerId,
                    circleAuthorizationToken: circle.authorizationJWT,
                    recipientId: circle.recipient.id,
                    circleChangeSponsorshipRequest: request,
                };
                return activationToken
                    ? api.v1ChangeSponsor(params, {
                          headers: {
                              [PARTNER_MEMBER_ACTIVATION_TOKEN_HEADER]:
                                  activationToken,
                          },
                      })
                    : api.v1ChangeSponsor(params);
            }
        );
    return {
        changeSponsorship: mutate,
        changeSponsorshipAsync: mutateAsync,
        ...otherProps,
    };
}
